/**
 * Athena Presentation Design System — Token Exports
 */

// ── Spacing scale (px) ────────────────────────────────────────────────────────
export const spacing = {
  1:  4,
  2:  8,
  3:  12,
  4:  16,
  5:  20,
  6:  24,
  8:  32,
  10: 40,
  12: 48,
  16: 64,
};

// ── Typography ────────────────────────────────────────────────────────────────
export const typography = {
  display:       { fontSize: 30, fontWeight: 800, lineHeight: 1.15, letterSpacing: '-0.03em' },
  title:         { fontSize: 22, fontWeight: 800, lineHeight: 1.2,  letterSpacing: '-0.025em' },
  titleSm:       { fontSize: 18, fontWeight: 800, lineHeight: 1.25, letterSpacing: '-0.02em' },
  sectionTitle:  { fontSize: 11, fontWeight: 800, lineHeight: 1.2,  letterSpacing: '0.09em', textTransform: 'uppercase' },
  body:          { fontSize: 14, fontWeight: 400, lineHeight: 1.65 },
  bodyCompact:   { fontSize: 13, fontWeight: 400, lineHeight: 1.55 },
  bodySm:        { fontSize: 13, fontWeight: 400, lineHeight: 1.60 },
  label:         { fontSize: 12, fontWeight: 500, lineHeight: 1.4 },
  caption:       { fontSize: 11, fontWeight: 400, lineHeight: 1.4 },
  metricValue:   { fontSize: 14, fontWeight: 700, lineHeight: 1.2, letterSpacing: '-0.01em', fontVariantNumeric: 'tabular-nums' },
  metricLabel:   { fontSize: 9.5, fontWeight: 600, lineHeight: 1.2, letterSpacing: '0.06em', textTransform: 'uppercase' },
  eyebrow:       { fontSize: 10, fontWeight: 800, lineHeight: 1.2, letterSpacing: '0.10em', textTransform: 'uppercase' },
  badge:         { fontSize: 10, fontWeight: 800, lineHeight: 1.2, letterSpacing: '0.07em', textTransform: 'uppercase' },
  chipText:      { fontSize: 12.5, fontWeight: 400, lineHeight: 1 },
};

// ── Border radius ─────────────────────────────────────────────────────────────
export const radius = {
  sm:       6,
  md:       10,
  lg:       14,
  hero:     14,
  pill:     20,
  circular: '50%',
};

// ── Shadows ───────────────────────────────────────────────────────────────────
export const shadows = {
  card:     '0 2px 16px rgba(0,0,0,0.2)',
  hero:     '0 4px 40px rgba(0,0,0,0.4), 0 1px 0 rgba(255,255,255,0.03) inset',
  floating: '0 8px 32px rgba(0,0,0,0.35)',
  focus:    '0 0 0 2px rgba(59,130,246,0.4)',
};

// ── Motion ────────────────────────────────────────────────────────────────────
export const motion = {
  fast:     '0.12s ease',
  normal:   '0.18s ease',
  slow:     '0.28s ease',
  spring:   'cubic-bezier(0.34, 1.56, 0.64, 1)',
  hoverScale: 'scale(1.015)',
  fadeIn:   'opacity 0.15s ease',
  slideDown: 'transform 0.18s ease, opacity 0.18s ease',
};

// ── Breakpoints ───────────────────────────────────────────────────────────────
export const breakpoints = {
  compact: 360,
  mobile:  768,
  tablet:  1024,
  desktop: 1440,
};

export { default as colors, base, semantic, accents, themes } from './colors';
